/* eslint-disable max-len */
import * as React from 'react';
import GenericHoc from '../generic-hoc';
import CreateModal from '../../create-consignment/create-modal';
import ConsignmentsIcon from '../../../assets/consignments';
import WalletIcon from '../../../assets/wallet';
import PincodeService from '../../pincode-service/service-availability';
import BulkConsignments from '../../create-consignment/bulk-consignments';
import TrackConsignment from '../../track-consignment/track-consignment';
import CreatePickup from '../../pickup/create-pickup/create-pickup';
import { Routes } from '../../../library/constants';
import {
    getAddressBookRoute,
    getConsignmentsRoute,
    getDownloadsRoute,
    getHeaderMappingRoute,
    getPickupRoute,
    getAppointmentsRoute,
    getInvoicesRoute,
    getVirtualInventoryRoute,
    getWalletLedgerRoute,
    getAdvanceShippingNoteRoute,
    getAsnExcelUploadRoute,
    getAnalyticsRoute,
    getAdditionalServicesRoute,
    getAPIPlaygroundRoute,
    getExcelUploadRoute,
    getPurchaseOrderRoute,
    getPrintHistoryRoute,
    getPieceHeaderMappingRoute,
    getInvoiceHeaderMappingRoute,
    getProductMappingRoute,
    getSettingsChannelRoute,
    getSettingsAccountRoute,
    getRateCalculatorRoute,
    getPincodeServiceabilityRoute,
    getUserManagement,
    getBlockedLedgerRoute,
    getBlockedAmountRoute,
    getSchedulePickupRoute,
} from '../../../routing/routing-helper';
import { RouteChildrenProps } from 'react-router';
import { CreateActions } from '../../create-consignment/create-modal.constants';
import { StylesProps } from '../../../theme/jss-types';
import { bindActionCreators } from 'redux';
import { HocOptions } from '../generic-hoc.types';
import {
    DownloadOutlined,
    PlusOutlined,
    SettingOutlined,
    QuestionCircleOutlined,
    HomeOutlined,
    AppstoreOutlined,
} from '@ant-design/icons';
import { Pincodes } from '../../../library/Types';
import SuccessPopup from '../../create-consignment/success-popup';
import moment from 'moment';
import {
    Avatar,
    Button,
    Divider,
    Menu,
    message,
    Select,
} from 'antd';
import { loadConsignments } from '../../../actions/consignment-actions';
import { Master } from 'types/master-data-types';
import { printConsignment, loginToChildCustomer } from 'network/consignments.api';
import Helper from 'library/Helper';
import { loadPickups } from 'actions/pickup-actions';
import BulkPickups from 'components/pickup/create-pickup/bulk-pickups';
import FailureList from '../../consignments/cancellation-failure';
import { useTranslation } from 'react-i18next';
import SingleHyperlocal from '../../create-hyperlocal/single-hyperlocal';
import SingleConsignmentNew from 'components/create-consignment/single-cn-creation/single-consignment-new';
import SingleConsignment from 'components/create-consignment/single-consignment';
import InformationCetreIcon from 'assets/information-center';
import { MenuItemSelected, SubmenuItems } from './side-menu.constants';
import { sideMenuStyles } from './side-menu.styles';
import classNames from 'classnames';
import { storeExpandingState } from 'actions/miscellaneous-actions';
import OnboardingModal from '../../custom-forms/onboarding-form';
import { isEmpty } from 'lodash';
import useIsMobile from 'hooks/useIsMobile';
import AuthHelper from '../../../auth/auth-helper';
import CustomFrontendEmbed from '../../custom-frontend/CustomFrontendEmbed';
import {
    CustomFrontendMenuEntry,
    findCustomFrontendApp,
    findCustomFrontendMenuById,
    getCustomFrontendMenu,
} from '../../custom-frontend/customFrontendManifest';

interface SideMenuProps extends RouteChildrenProps, StylesProps<ReturnType<typeof sideMenuStyles>> {
    loadconsignments: () => void;
    loadpickups: () => void;
    master: Master;
    isRTL: boolean;
    showCreate: boolean;
    setCreateVisible: (isVisible: boolean) => void;
    showGetStartedModal: () => void;
    setStateForExpandAction: (state: Record<any, any>) => void;
    routesInfo: Record<any, any>;
}

const SideMenu = (props: SideMenuProps) => {
    const {
        classes,
        location,
        history,
        loadconsignments,
        loadpickups,
        master,
        isRTL,
        showCreate,
        setCreateVisible,
        showGetStartedModal,
        setStateForExpandAction,
        routesInfo,
    } = props;
    const [isMenuCollapsed, setMenuCollapsed] = React.useState<boolean>(true);
    const [createVisible, setCreateVisibility] = React.useState<boolean>(false);
    const [current, setCurrent] = React.useState<MenuItemSelected>({ key: Routes.CONSIGNMENTS });
    const [pincodes, setPincodes] = React.useState<Pincodes>({});
    const [referenceNumber, setReferenceNumber] = React.useState<string>();
    const [formVisible, setFormVisible] = React.useState<CreateActions | undefined>(
        // CreateActions.SingleConsignment,
    );
    const customerProperties = master?.properties;
    const customerPermissions = master?.customerUserPermissions;
    let showSettingsSection = true;
    let showUserManagement = true;
    let showVirtualInventory = master?.parts_to_show?.virtual_series;
    const freshdeskJWTSSOSPInitiationUrl = master?.config?.freshdesk_customer_login_sp_request_url;
    const [successVisible, setSuccessVisible] = React.useState<any>({});
    const phoneRegex = master?.parts_to_show?.remove_regex ? null : master?.config?.phone_regex;
    const storage = window.localStorage;
    const enable_customer_config = master?.parts_to_show?.enable_customer_config || false;
    const children_list = master?.children_list || [];
    let useThirdPartyLabel = false;
    if (customerProperties && enable_customer_config) {
        useThirdPartyLabel = customerProperties?.use_third_party_label;
        showUserManagement = customerPermissions?.user_management;
        showVirtualInventory = showVirtualInventory && customerProperties?.virtual_inventory && customerPermissions?.virtual_inventory;
        const showHeaderMapping = customerProperties?.header_mapping_settings;
        const showProductCodeMapping = customerProperties?.product_code_mapping_settings;
        showSettingsSection = (showHeaderMapping || showProductCodeMapping || showVirtualInventory || showUserManagement) && customerPermissions?.setting;
    }
    const currentRoute = Helper.getCurrentRoute();
    const { t } = useTranslation();
    const logoUrl = master?.Customer?.logo_url;
    const menuItemList = React.useMemo(() => [
        {
            key: Routes.ANALYTICS,
            icon: <HomeOutlined />,
            label: t('overview'),
        }, {
            key: SubmenuItems.SHIPMENT,
            icon: <ConsignmentsIcon />,
            label: t(SubmenuItems.SHIPMENT),
            is_visible: true,
            isSubmenu: true,
            className: 'shipment-details',
            children: [
                {
                    key: Routes.CONSIGNMENTS,
                    label: t('consignments'),
                },
                {
                    key: Routes.PICKUPS,
                    label: t('pickups'),
                },
                {
                    key: Routes.PURCHASE_ORDER,
                    label: t('purchase_orders'),
                },
                {
                    key: Routes.EXCEL_UPLOAD,
                    label: t('excel_uploaded'),
                },
                {
                    key: Routes.PRINT_HISTORY,
                    label: t('print_history'),
                },
                {
                    key: Routes.ASN,
                    label: t('asn'),
                },
                {
                    key: Routes.ADDITIONAL_SERVICES,
                    label: t('supplementary_services'),
                },
            ],
        }, {
            key: SubmenuItems.FINANCES,
            icon: <WalletIcon />,
            label: t(SubmenuItems.FINANCES),
            is_visible: true,
            isSubmenu: true,
            className: 'finances',
            children: [
                {
                    key: Routes.WALLET_LEDGER,
                    label: t('wallet_ledger_statement'),
                },
                {
                    key: Routes.BLOCKED_AMOUNT_LEDGER,
                    label: t('blocked_amount_statement'),
                },
                {
                    key: Routes.RECHARGE_TRANSACTIONS,
                    label: t('recharge_transactions'),
                },
            ],
        }, {
            key: SubmenuItems.SETTINGS,
            icon: <SettingOutlined />,
            label: t(SubmenuItems.SETTINGS),
            is_visible: showSettingsSection,
            isSubmenu: true,
            className: 'settings',
            children: [
                {
                    key: Routes.VIRTUAL_INVENTORY,
                    label: t('virtual_inventory'),
                },
                {
                    key: Routes.SETTINGS_HEADER,
                    label: t('header_mapping'),
                },
                {
                    key: Routes.SETTINGS_PIECE_HEADER,
                    label: t('piece_header_mapping'),
                },
                {
                    key: Routes.SETTINGS_INVOICE_HEADER,
                    label: t('invoice_header_mapping'),
                },
                {
                    key: Routes.SETTINGS_PRODUCT,
                    label: t('product_code_mapping'),
                },
                {
                    key: Routes.SETTINGS_ACCOUNT,
                    label: t('account_settings'),
                },
                {
                    key: Routes.SCHEDULE_PICKUP,
                    label: t('schedule_pickup'),
                },
                {
                    key: Routes.APPOINTMENTS,
                    label: t('appointments'),
                },
                {
                    key: Routes.INVOICES,
                    label: t('invoices'),
                },
                {
                    key: Routes.USER_MANAGEMENT,
                    label: t('user_management'),
                },
            ],
        }, {
            key: Routes.DOWNLOADS,
            icon: <DownloadOutlined />,
            label: t('downloads'),
            is_visible: true,
        }, {
            key: SubmenuItems.INFORMATION,
            icon: <InformationCetreIcon />,
            label: t(SubmenuItems.INFORMATION),
            is_visible: true,
            isSubmenu: true,
            className: 'information-center',
            children: [
                {
                    key: Routes.RATE_CALCULATOR,
                    label: t('rate_calculator'),
                },
                {
                    key: Routes.PINCODE_SERVICEABILITY,
                    label: t('pincode_serviceability'),
                },
                {
                    key: Routes.ADDRESS_BOOK,
                    label: t('address_book'),
                },
                {
                    key: Routes.API_PLAYGROUND,
                    label: t('api_playground'),
                },
            ],
        },
        ...getCustomFrontendMenu().map((m) => ({
            key: `custom:${m.id}`,
            icon: <AppstoreOutlined />,
            label: t(m.label),
        })),
    ], [t, showSettingsSection, master?.custom_frontend_manifest]);

    const [failures, setFailures] = React.useState<any>({
        visible: false,
        list: [],
    });

    const [selectedCustomer, setSelectedCustomer] = React.useState<any>(window.localStorage.getItem('childCustomerCode'));
    const allow_child_login_on_parent = master?.parts_to_show?.allow_child_login_on_parent || false;

    const loadChildCustomer = async () => {
        const customer = window.localStorage.getItem('childCustomerCode');
        const childCustomer = children_list?.find((item: any) => item.customer_code === customer);
        const customerToShow = childCustomer?.customer_code || customer;
        setSelectedCustomer(customerToShow);
    };
    const [openedSubMenu, setOpenedSubMenu] = React.useState<Array<string>>([]);


    const handleCloseForm = () => {
        setFormVisible(undefined);
        setPincodes({});
    };
    const isMobile = useIsMobile();
    React.useEffect(() => {
        // const currentPage = getCurrentPage(location);
        let currentPage: MenuItemSelected | undefined;
        switch (Helper.getCurrentRoute()) {
            case Routes.ANALYTICS:
                currentPage = {
                    key: Routes.ANALYTICS,
                };
                break;
            case Routes.PICKUPS:
                currentPage = {
                    key: Routes.PICKUPS,
                    isSubmenu: true,
                    submenuKey: SubmenuItems.SHIPMENT,
                };
                break;
            case Routes.APPOINTMENTS:
                currentPage = {
                    key: Routes.APPOINTMENTS,
                    isSubmenu: true,
                    submenuKey: SubmenuItems.SETTINGS,
                };
                break;
            case Routes.EXCEL_UPLOAD:
                currentPage = {
                    key: Routes.EXCEL_UPLOAD,
                    isSubmenu: true,
                    submenuKey: SubmenuItems.SHIPMENT,
                };
                break;
            case Routes.PURCHASE_ORDER:
                currentPage = {
                    key: Routes.PURCHASE_ORDER,
                    isSubmenu: true,
                    submenuKey: SubmenuItems.SHIPMENT,
                };
                break;
            case Routes.PRINT_HISTORY:
                currentPage = {
                    key: Routes.PRINT_HISTORY,
                    isSubmenu: true,
                    submenuKey: SubmenuItems.SHIPMENT,
                };
                break;
            case Routes.ASN:
                currentPage = {
                    key: Routes.ASN,
                    isSubmenu: true,
                    submenuKey: SubmenuItems.SHIPMENT,
                };
                break;
            case Routes.ASN_EXCEL_UPLOAD:
                currentPage = {
                    key: Routes.ASN,
                    isSubmenu: true,
                    submenuKey: SubmenuItems.SHIPMENT,
                };
                break;
            case Routes.ADDITIONAL_SERVICES:
                currentPage = {
                    key: Routes.ADDITIONAL_SERVICES,
                    isSubmenu: true,
                    submenuKey: SubmenuItems.SHIPMENT,
                };
                break;
            case Routes.WALLET_LEDGER:
                currentPage = {
                    key: Routes.WALLET_LEDGER,
                    isSubmenu: true,
                    submenuKey: SubmenuItems.FINANCES,
                };
                break;
            case Routes.BLOCKED_AMOUNT_LEDGER:
                currentPage = {
                    key: Routes.BLOCKED_AMOUNT_LEDGER,
                    isSubmenu: true,
                    submenuKey: SubmenuItems.FINANCES,
                };
                break;
            case Routes.RECHARGE_TRANSACTIONS:
                currentPage = {
                    key: Routes.RECHARGE_TRANSACTIONS,
                    isSubmenu: true,
                    submenuKey: SubmenuItems.FINANCES,
                };
                break;
            case Routes.VIRTUAL_INVENTORY:
                currentPage = {
                    key: Routes.VIRTUAL_INVENTORY,
                    isSubmenu: true,
                    submenuKey: SubmenuItems.SETTINGS,
                };
                break;
            case Routes.SETTINGS_HEADER:
                currentPage = {
                    key: Routes.SETTINGS_HEADER,
                    isSubmenu: true,
                    submenuKey: SubmenuItems.SETTINGS,
                };
                break;
            case Routes.SETTINGS_PIECE_HEADER:
                currentPage = {
                    key: Routes.SETTINGS_PIECE_HEADER,
                    isSubmenu: true,
                    submenuKey: SubmenuItems.SETTINGS,
                };
                break;
            case Routes.SETTINGS_INVOICE_HEADER:
                currentPage = {
                    key: Routes.SETTINGS_INVOICE_HEADER,
                    isSubmenu: true,
                    submenuKey: SubmenuItems.SETTINGS,
                };
                break;
            case Routes.SETTINGS_PRODUCT:
                currentPage = {
                    key: Routes.SETTINGS_PRODUCT,
                    isSubmenu: true,
                    submenuKey: SubmenuItems.SETTINGS,
                };
                break;
            case Routes.SETTINGS_CHANNEL:
                currentPage = {
                    key: Routes.SETTINGS_CHANNEL,
                    isSubmenu: true,
                    submenuKey: SubmenuItems.SETTINGS,
                };
                break;
            case Routes.SCHEDULE_PICKUP:
                currentPage = {
                    key: Routes.SCHEDULE_PICKUP,
                    isSubmenu: true,
                    submenuKey: SubmenuItems.SETTINGS,
                };
                break;
            case Routes.API_PLAYGROUND:
                currentPage = {
                    key: Routes.API_PLAYGROUND,
                    isSubmenu: true,
                    submenuKey: SubmenuItems.SETTINGS,
                };
                break;
            case Routes.INVOICES:
                currentPage = {
                    key: Routes.INVOICES,
                    isSubmenu: true,
                    submenuKey: SubmenuItems.SETTINGS,
                };
                break;
            case Routes.SETTINGS_ACCOUNT:
                currentPage = {
                    key: Routes.SETTINGS_ACCOUNT,
                    isSubmenu: true,
                    submenuKey: SubmenuItems.SETTINGS,
                };
                break;
            case Routes.DOWNLOADS:
                currentPage = {
                    key: Routes.DOWNLOADS,
                };
                break;
            case Routes.ADDRESS_BOOK:
                currentPage = {
                    key: Routes.ADDRESS_BOOK,
                    isSubmenu: true,
                    submenuKey: SubmenuItems.INFORMATION,
                };
                break;
            case Routes.RATE_CALCULATOR:
                currentPage = {
                    key: Routes.RATE_CALCULATOR,
                    isSubmenu: true,
                    submenuKey: SubmenuItems.INFORMATION,
                };
                break;
            case Routes.PINCODE_SERVICEABILITY:
                currentPage = {
                    key: Routes.PINCODE_SERVICEABILITY,
                    isSubmenu: true,
                    submenuKey: SubmenuItems.INFORMATION,
                };
                break;
            case Routes.USER_MANAGEMENT:
                currentPage = {
                    key: Routes.USER_MANAGEMENT,
                    isSubmenu: true,
                    submenuKey: SubmenuItems.SETTINGS,
                };
                break;
            case Routes.CONSIGNMENTS:
            default:
                currentPage = {
                    key: Routes.CONSIGNMENTS,
                    isSubmenu: true,
                    submenuKey: SubmenuItems.SHIPMENT,
                };
                break;
        }
        setCurrent(currentPage || current);
    }, [location, isMobile]);

    React.useEffect(() => {
        loadChildCustomer();
    }, []);

    const getRoute = (action: any) => {
        switch (action.key) {
            case 'pickups': return getPickupRoute();
            case Routes.APPOINTMENTS: return getAppointmentsRoute();
            case 'invoices': return getInvoicesRoute();
            case 'virtual-inventory': return getVirtualInventoryRoute();
            case 'downloads': return getDownloadsRoute();
            case 'wallet': return getWalletLedgerRoute();
            case 'settings': return getHeaderMappingRoute();
            case 'asn': return getAdvanceShippingNoteRoute();
            case 'analytics': return getAnalyticsRoute();
            case 'api-playground': return getAPIPlaygroundRoute();
            case 'address-book': return getAddressBookRoute();
            case Routes.ASN_EXCEL_UPLOAD: return getAsnExcelUploadRoute();
            case Routes.ADDITIONAL_SERVICES: return getAdditionalServicesRoute();
            case Routes.EXCEL_UPLOAD: return getExcelUploadRoute();
            case Routes.PURCHASE_ORDER: return getPurchaseOrderRoute();
            case Routes.PRINT_HISTORY: return getPrintHistoryRoute();
            case Routes.WALLET_LEDGER: return getWalletLedgerRoute();
            case Routes.BLOCKED_AMOUNT_LEDGER: return getBlockedAmountRoute();
            case Routes.RECHARGE_TRANSACTIONS: return getBlockedLedgerRoute();
            case Routes.SETTINGS_HEADER: return getHeaderMappingRoute();
            case Routes.SETTINGS_PIECE_HEADER: return getPieceHeaderMappingRoute();
            case Routes.SETTINGS_INVOICE_HEADER: return getInvoiceHeaderMappingRoute();
            case Routes.SETTINGS_PRODUCT: return getProductMappingRoute();
            case Routes.SETTINGS_CHANNEL: return getSettingsChannelRoute();
            case Routes.SETTINGS_ACCOUNT: return getSettingsAccountRoute();
            case Routes.SCHEDULE_PICKUP: return getSchedulePickupRoute();
            case Routes.RATE_CALCULATOR: return getRateCalculatorRoute();
            case Routes.PINCODE_SERVICEABILITY: return getPincodeServiceabilityRoute();
            case Routes.USER_MANAGEMENT: return getUserManagement();
            case 'consignments':
            default: return getConsignmentsRoute();
        }
    };
    const handleCustomFrontendNavigation = (entry: CustomFrontendMenuEntry) => {
        const app = findCustomFrontendApp(entry.appId);
        if (!app) {
            message.error(t('Unable to launch Custom Frontend'));
            return;
        }
        // Same kebab JSON the portal already emits in CREDENTIALS_SHARING —
        // customer_portal's payloadSchema is shared between transports. Nulls
        // are dropped (storage misses come back null).
        const headers = AuthHelper.getAuthenticationHeaders();
        const payload: Record<string, string> = {};
        Object.entries({
            'user-id': headers['user-id'],
            'organisation-id': headers['organisation-id'],
            'access-token': headers['access-token'],
            'application-type': headers['application-type'],
            'customer-user-id': headers['customer-user-id'],
        }).forEach(([key, value]) => {
            if (value) payload[key] = value;
        });
        // Creds ride in the URL hash (not sent to server / not in Referer).
        // Custom-frontend reads the hash on load, persists, then strips it.
        const auth = window.btoa(JSON.stringify(payload))
            .replace(/\+/g, '-')
            .replace(/\//g, '_')
            .replace(/=+$/, '');
        // `?source=customer_portal` identifies this host to the embedded SPA's
        // multi-host bootstrap; without it the SPA throws SourceMissingError.
        const target = entry.iframeRoute && entry.iframeRoute !== '/'
            ? `${app.url}${entry.iframeRoute}?source=customer_portal#auth=${auth}`
            : `${app.url}/?source=customer_portal#auth=${auth}`;
        window.open(target, '_blank', 'noopener,noreferrer');
    };

    const handleTabChange = (action: any) => {
        if (typeof action.key === 'string' && action.key.startsWith('custom:')) {
            const entry = findCustomFrontendMenuById(action.key.slice('custom:'.length));
            if (!entry) return;
            if (entry.target === 'inApp') {
                history.push(entry.iframeRoute);
            } else {
                handleCustomFrontendNavigation(entry);
            }
            return;
        }
        if (currentRoute === Routes.PINCODE_SERVICEABILITY || currentRoute === Routes.RATE_CALCULATOR) {
            setStateForExpandAction({});
        }
        const route = getRoute(action);
        history.push(route);
    };

    const closeModal = () => {
        setCreateVisibility(false);
        setCreateVisible(false);
    };

    const handleCreate = (e: any, action: CreateActions) => {
        e.stopPropagation();
        setFormVisible(action);
        closeModal();
    };

    const renderCreateModal = () => {
        if (!createVisible && !showCreate) {
            return null;
        }
        return (
            <CreateModal
                onClose={() => closeModal()}
                setPincodes={setPincodes}
                setReferenceNumber={setReferenceNumber}
                pincodes={pincodes}
                referenceNumber={referenceNumber}
                handleCreate={(e: any, action: CreateActions) => handleCreate(e, action)}
                isRTL={isRTL}
            />
        );
    };

    const renderButton = () => {
        return (
            <Button
                style={{
                    width: '100%',
                }}
                onClick={(e) => {
                    e.preventDefault();
                    setOpenedSubMenu([]);
                    setMenuCollapsed(true);
                    setCreateVisibility(true);
                }}
                className={classNames(classes.addNewButton, 'new-booking')}
            >
                <PlusOutlined style={{ color: '#111111' }} className={classes.buttonIcon} />
                {isMenuCollapsed ? '' : t('new_request')}
            </Button>
        );
    };

    const renderSupportButton = () => {
        return (
            <Button
                onClick={() => window.open(freshdeskJWTSSOSPInitiationUrl, '_blank')}
                className={classes.supportButton}
            >
                <QuestionCircleOutlined style={{ color: '#111111' }} className={classes.buttonIcon} />
                {isMenuCollapsed ? '' : t('help_support')}
            </Button>
        );
    };

    const renderTourButton = () => {
        return (
            <Button
                onClick={showGetStartedModal}
                className={classes.tourButton}
            >
                <div className={classes.rocket}>🚀</div>
                {isMenuCollapsed ? '' : t('explore_new_look')}
            </Button>
        );
    };

    const handleChildCustomerChange = async (val:any) => {
        const selectedCustomerObject = children_list.find((item: any) => item.customer_code === val);
        const selectedCustomerId = selectedCustomerObject?.customer_id;
        // const parentCode = storage.getItem('userCode') || null;
        storage.setItem('isChildCustomer', 'false');
        // if customer is child customer , call login to child customer api
        if (selectedCustomerId !== master?.CustomerUserDetails?.customer_id) {
            const login_obj = {
                customer_code: val,
                parent_customer_id: storage.getItem('userId'),
            };
            storage.setItem('isChildCustomer', 'true');
            const res = await loginToChildCustomer(login_obj);
            if (res.isSuccess) {
                if (res?.data?.Customer) {
                    storage.setItem('childCustomerId', res.data.Customer.id);
                    storage.setItem('childCustomerCode', res.data.Customer.code);
                    storage.setItem('childCustomerUserId', res?.data?.CustomerUserDetails?.id);
                }
                if (res?.data?.access_token) {
                    storage.setItem('childAccessToken', res.data.access_token.id);
                }
                window.location.reload();
            } else {
                message.error(res.errorMessage);
            }
        } else {
            const userId = storage.getItem('userId') || '';
            const token = storage.getItem('authToken') || '';
            const userCode = storage.getItem('userCode') || '';
            const customerUserId = storage.getItem('customerUserId') || '';
            storage.setItem('isChildCustomer', 'false');
            storage.setItem('childCustomerId', userId);
            storage.setItem('childCustomerCode', userCode);
            storage.setItem('childAccessToken', token);
            storage.setItem('childCustomerUserId', customerUserId);
            window.location.reload();
        }
    };

    const renderDropdown = () => {
        if (!allow_child_login_on_parent) {
            return null;
        }
        const optionList = children_list?.map((item: any) => {
            return {
                value: item.customer_code,
                label: `${item.customer_code} (${item.customer_name})`,
            };
        });
        return (
            <>
                <div className={classes.customerSwitch}>
                    <div className={classes.customerLogo}>
                        <Avatar
                            size="small"
                            shape="square"
                            src={logoUrl || undefined}
                        >
                            {logoUrl ? null : (selectedCustomer?.[0] || 'U')?.toUpperCase()}
                        </Avatar>
                    </div>
                    <Select
                        placeholder="Select Account"
                        style={{ display: isMenuCollapsed ? 'none' : '' }}
                        dropdownMatchSelectWidth={false}
                        className={classes.childDropdown}
                        defaultValue={selectedCustomer}
                        onChange={handleChildCustomerChange}
                        showSearch
                        allowClear
                        options={optionList}
                        filterOption={(query, option: any) => {
                            return option?.label?.toUpperCase()?.includes(query.toUpperCase());
                        }}
                        bordered={false}
                    />
                </div>
                <Divider type="horizontal" className={classes.divider} />
            </>
        );
    };

    const handleCreation = (action: CreateActions, data: any) => {
        setFormVisible(undefined);
        setSuccessVisible({
            action,
            data,
            creationTime: moment().format('DD MMM YYYY | hh:mm A'),
        });
    };

    const renderSingleConsignment = () => {
        if (formVisible !== CreateActions.SingleConsignment && formVisible !== CreateActions.FTLHyperlocal) {
            return null;
        }
        const isConfigEnabled = master.config?.customer_portal_order_creation_config?.is_enabled;
        return (
            // If the manifest declares a `consignment-add` slot, the
            // custom-frontend iframe takes over; otherwise the existing
            // portal forms render as the fallback (mirrors CRM's anc embed).
            <CustomFrontendEmbed
                slot="consignment-add"
                onClose={() => {
                    handleCloseForm();
                    loadconsignments();
                }}
            >
                {isConfigEnabled
                    ? (
                        <SingleConsignmentNew
                            config={master}
                            onClose={handleCloseForm}
                            setSuccess={(data: any) => {
                                handleCreation(CreateActions.SingleConsignment, data);
                            }}
                            loadconsignments={loadconsignments}
                            isRTL={isRTL}
                            actionType={formVisible}
                        />
                    )
                    : (
                        <SingleConsignment
                            config={master}
                            onClose={handleCloseForm}
                            setSuccess={(data: any) => {
                                handleCreation(CreateActions.SingleConsignment, data);
                            }}
                            loadconsignments={loadconsignments}
                            actionType={formVisible}
                            isRTL={isRTL}
                        />
                    )}
            </CustomFrontendEmbed>
        );
    };

    const renderBulkConsignment = () => {
        if (formVisible !== CreateActions.BulkConsignment) {
            return null;
        }
        return (
            <BulkConsignments
                onClose={handleCloseForm}
                config={{
                    name: t('add_consignment'),
                    uploadName: t('consignments'),
                }}
                allowInternational={master?.parts_to_show?.allow_international_booking || false}
                showServiceTypeOption={
                    master?.config?.customer_portal_config?.download_static_international_sample_file || false
                }
                itemArrayInDomestic={master?.parts_to_show?.enable_piece_items_detail || false}
                allowPieces={master?.parts_to_show?.allow_pieces_in_consignment_customer_portal_excel || false}
            />
        );
    };

    const renderTrack = () => {
        if (formVisible !== CreateActions.Track) {
            return null;
        }
        return (
            <TrackConsignment
                referenceNumber={referenceNumber}
                onClose={handleCloseForm}
            />
        );
    };

    const renderSinglePickup = () => {
        if (formVisible !== CreateActions.SinglePickup) {
            return null;
        }
        return (
            <CreatePickup
                onClose={handleCloseForm}
                loadpickups={loadpickups}
                setSuccess={(data: any) => {
                    setFormVisible(undefined);
                    if (data?.existingPickupTaskMessage) {
                        message.info(data.existingPickupTaskMessage);
                    } else {
                        message.success(`Pickup Created, PickupId = ${data.pickupId}`);
                    }
                }}
                phoneRegex={phoneRegex}
                config={master?.config}
            />
        );
    };

    const renderBulkPickup = () => {
        if (formVisible !== CreateActions.BulkPickup) {
            return null;
        }
        return (
            <BulkPickups
                onClose={handleCloseForm}
                config={{
                    name: t('add_bulk_pickup'),
                    uploadName: t('bulk_pickup'),
                }}
                success={() => {
                    loadpickups();
                    history.push('/pickups');
                }}
                setFailure={(failureList: any) => {
                    setFormVisible(undefined);
                    setFailures({
                        visible: true,
                        list: failureList,
                        referenceNumberTitle: 'row',
                    });
                }}
            />
        );
    };

    const renderPincodeService = () => {
        if (formVisible !== CreateActions.PincodeAvailability) {
            return null;
        }
        return (
            <PincodeService
                pincodes={pincodes}
                onClose={handleCloseForm}
                shouldRenderInDrawer
            />
        );
    };

    const handlePrintLabel = (fileBuffer: any, fileName: string) => {
        if (fileBuffer.isSuccess) {
            const name = fileBuffer.filename || fileName;
            Helper.downloadFileData(
                fileBuffer.data,
                name,
                true,
                'pdf',
            );
            message.success('Success');
        } else {
            message.error('Failed to generate PDF!');
        }
    };

    const handlePrint = async (referenceNumbers: any, isSmall: boolean, fileName: string) => {
        const fileBuffer = await printConsignment({
            isSmall,
            referenceNumbers,
            useThirdPartyLabel,
        });
        handlePrintLabel(fileBuffer, fileName);
    };

    const handleProtipActions = (action: string) => {
        if (action === 'view') {
            setSuccessVisible({});
            history.push(getConsignmentsRoute());
            loadconsignments();
        }
        if (action === 'print') {
            const refNumber = successVisible.data.referenceNumber;
            handlePrint([refNumber], true, `Shipping_Label_${refNumber}.pdf`);
        }
        if (action === 'close') {
            setSuccessVisible({});
        }
        if (action === 'addSuppServices') {
            setSuccessVisible({});
            localStorage.setItem('supplementaryServiceConsignmentReferenceNumber', successVisible.data.referenceNumber);
            history.push(getAdditionalServicesRoute());
        }
    };

    const renderSuccess = () => {
        if (!successVisible.action) {
            return null;
        }
        return (
            <SuccessPopup
                // successArray={[1, 2]}
                // failureArray={[1, 2]}
                action={successVisible.action}
                data={successVisible.data}
                creationTime={successVisible.creationTime}
                handleAction={handleProtipActions}
                showSupplementaryServices={
                    master?.config?.customer_portal_order_creation_config?.show_supplementary_services
                }
            />
        );
    };

    const renderSingleHyperlocal = () => {
        if (formVisible !== CreateActions.SingleHyperlocal) {
            return null;
        }
        return (
            <SingleHyperlocal
                // config={master}
                onClose={handleCloseForm}
                visible
                // setSuccess={(data: any) => {
                //     handleCreation(CreateActions.SingleHyperlocal, data);
                // }}
                loadconsignments={loadconsignments}
            />
        );
    };
    //     if (formVisible !== CreateActions.BulkHyperlocal) {
    //         return null;
    //     }
    //     return null;
    // return (
    //     <BulkHyperlocal
    //         onClose={handleCloseForm}
    //         config={{
    //             name: t('add_consignment'),
    //             uploadName: t('consignments'),
    //         }}
    //         allowInternational={master?.parts_to_show?.allow_international_booking || false}
    //         showServiceTypeOption={
    //             master?.config?.customer_portal_config?.download_static_international_sample_file || false
    //         }
    //         itemArrayInDomestic={master?.parts_to_show?.enable_piece_items_detail || false}
    //     />
    // );
    // };

    const renderForms = () => {
        if (!formVisible) {
            return null;
        }
        return (
            <>
                {renderSingleHyperlocal()}
                {renderSingleConsignment()}
                {renderBulkConsignment()}
                {renderSinglePickup()}
                {renderBulkPickup()}
                {renderPincodeService()}
                {renderTrack()}
            </>
        );
    };

    // const openWindowWithPostRequest = () => {
    //     const customerCode = storage.getItem('userCode');
    //     if (!RTODashboardURL || !customerCode) {
    //         return;
    //     }
    //     const winName = 'RTO Dashboard';
    //     const winURL = `${RTODashboardURL}?custcode=${customerCode}`;
    //     const windowoption = 'resizable=yes,height=600,width=800,location=0,menubar=0,scrollbars=1';
    //     const form = document.createElement('form');
    //     form.setAttribute('method', 'post');
    //     form.setAttribute('action', winURL);
    //     form.setAttribute('target', winName);
    //     document.body.appendChild(form);
    //     window.open('', winName, windowoption);
    //     form.target = winName;
    //     form.submit();
    //     document.body.removeChild(form);
    // };

    const menuItems = React.useMemo(() => {
        let topMenuItem = master?.config?.top_menu_item?.filter(Helper.onlyUnique);

        if (!Helper.isValidArray(topMenuItem)) {
            topMenuItem = [];
        }
        const topmenuItems = topMenuItem?.map((item) => item.toLowerCase()) || [];

        let priorityMenuItems = topmenuItems?.map((item) => {
            const menuItem = menuItemList.find((menu) => menu.key === item);
            return menuItem;
        }) || [];
        priorityMenuItems = priorityMenuItems.filter((item) => item);
        const remainingMenuItems = menuItemList.filter((item) => !topmenuItems?.includes(item.key)) || [];

        const finalmenuItemList = [...priorityMenuItems, ...remainingMenuItems];

        return finalmenuItemList.map((item: any) => {
            if (item.isSubmenu) {
                const submenuChildren = item.children
                    .filter((child: any) => {
                        if (routesInfo[child.key] && routesInfo[child.key]?.isProtected
                            && !routesInfo[child.key].isVisible) {
                            return false;
                        }
                        return true;
                    })
                    .map((child: any) => ({
                        key: child.key,
                        label: child.label,
                    }));

                if (submenuChildren.length === 0) {
                    return null;
                }

                return {
                    key: item.key,
                    icon: item.icon,
                    label: item.label,
                    className: classNames(classes.SubMenu, item.className || ''),
                    children: submenuChildren,
                    onTitleClick: () => {
                        if (openedSubMenu.includes(item.key)) {
                            setOpenedSubMenu([]);
                        } else {
                            setOpenedSubMenu([item.key]);
                        }
                    },
                };
            }

            if (routesInfo[item.key] && routesInfo[item.key]?.isProtected
                && !routesInfo[item.key].isVisible) {
                return null;
            }

            return {
                key: item.key,
                icon: item.icon,
                label: item.label,
            };
        }).filter((item: any) => item !== null);
    }, [menuItemList, master?.config?.top_menu_item, routesInfo, classes.SubMenu, openedSubMenu]);

    const renderFailure = () => {
        if (!failures.visible || !failures?.list?.length) {
            return null;
        }
        return (
            <FailureList
                failureList={failures.list}
                onClose={() => setFailures({ visible: false })}
                referenceNumberTitle={failures?.referenceNumberTitle}
            />
        );
    };


    const renderOnboardingForm = () => {
        const formMetadata = master?.customer_portal_onboarding_form_metadata;
        if (!master?.show_onboarding_form || isEmpty(formMetadata)) {
            return null;
        }
        const params = { isVisible: master?.show_onboarding_form, formMetadata };
        return (
            <OnboardingModal params={params} />
        );
    };

    if (master.fetchingMaster) {
        return null;
    }

    return (
        <>
            {renderOnboardingForm()}
            <div
                className={classNames(classes.main, 'navigation-menu')}
                style={{ width: isMenuCollapsed ? 56 : 244 }}
                onMouseEnter={() => {
                    if (current.isSubmenu) {
                        setOpenedSubMenu([current.submenuKey]);
                    }
                    if (!createVisible && !showCreate && !formVisible && !successVisible.action
                        && (!failures.visible || !failures?.list?.length)) {
                        setMenuCollapsed(false);
                    }
                }}
                onMouseLeave={() => {
                    setOpenedSubMenu([]);
                    setMenuCollapsed(true);
                }}
            >
                <div>
                    {renderDropdown()}
                    {renderButton()}
                </div>
                <Menu
                    style={{ overflowY: 'auto', overflowX: 'hidden' }}
                    mode="inline"
                    selectable
                    theme="light"
                    selectedKeys={[current.key]}
                    className={classes.sideMenu}
                    onClick={handleTabChange}
                    inlineCollapsed={isMenuCollapsed}
                    openKeys={isMenuCollapsed ? [''] : openedSubMenu}
                    items={menuItems}
                />
                <div className={classes.sideMenuBottom}>
                    {renderTourButton()}
                    {freshdeskJWTSSOSPInitiationUrl ? renderSupportButton() : null}
                </div>
                {renderCreateModal()}
                {renderForms()}
                {renderSuccess()}
                {renderFailure()}
            </div>
            <div className={classes.dummyClassForSpace} />
        </>
    );
};

const mapStateToProps = (state: any) => {
    const {
        master, navigation, uiTheme, miscellaneousState,
    } = state;
    return {
        master,
        navigation,
        isRTL: uiTheme?.isRTL,
        routesInfo: miscellaneousState?.ROUTES_INFO || {},
    };
};

const mapDispatchToProps = (dispatch: any) => {
    const actions = {
        loadconsignments: loadConsignments,
        loadpickups: loadPickups,
        setStateForExpandAction: storeExpandingState,
    };
    return bindActionCreators(actions, dispatch);
};

const hocConfig: HocOptions = {
    connectRouter: true,
    connectJss: {
        useJss: true,
        styleSheet: sideMenuStyles,
    },
    connectRedux: {
        useRedux: true,
        mapStateToProps,
        mapDispatchToProps,
    },
    connectTranslession: true,
};

export default GenericHoc(hocConfig)(SideMenu);
